import { ValueConditionalStylesProps } from "@/components/TableColumnSelector/Interface"
import { EmployeeProps } from "./employee_type"

export type BidProps = {
    bid_id: string
    bid_name: string
    start_date?: string
    end_date?: string
    status: string
    category: string
    folder_location?: string
    description?: string
    template?: string
    no_date_due?: boolean
    isDeadline?: boolean
    manager?: EmployeeProps
    city?: string
    follow_up_date?: string
}

export type BidFormCreationProps = {
    bid_id?: string
    bid_name: string
    start_date?: string
    end_date?: string
    city?: string
    status: string
    category: string
    folder_location?: string
    description?: string
    template?: string
    no_date_due?: boolean
    isDeadline?: boolean
    manager?: string
    follow_up_date?: string
}

export type BidCategory = "Shell" | "Service Call" | "Design" | "Finishout" | "Commercial" | "Apartment" | "Utility" | "Warehouse" | "Retrofit"
export const BidCategoryOptions: {value: BidCategory, label: BidCategory}[] = [
    {value: "Shell", label: "Shell"},
    {value: "Service Call", label: "Service Call"},
    {value: "Design", label: "Design"},
    {value: "Finishout", label: "Finishout"},
    {value: "Commercial", label: "Commercial"},
    {value: "Apartment", label: "Apartment"},
    {value: "Utility", label: "Utility"},
    {value: "Warehouse", label: "Warehouse"},
    {value: "Retrofit", label: "Retrofit"},
]
export const BID_CATEGORY = [
    "Shell",
    "Service Call",
    "Design",
    "Finishout",
    "Commercial",
    "Apartment",
    "Utility",
    "Warehouse",
    "Retrofit",
] as const

export const BID_STATUS_VALUE_CONDITIONAL_STYLES: ValueConditionalStylesProps[] = [
    {
        when: (value) => value === "Active",
        style: {
            backgroundColor: "var(--status-active)"
        }
    },
    {
        when: (value) => value === "Completed",
        style: {
            backgroundColor: "var(--status-completed)"
        }
    },
    {
        when: (value) => value === "Awarded",
        style: {
            backgroundColor: "var(--status-review)"
        }
    },
]

export type BidStatus = "Active" | "Completed" | "Awarded" | "Not Awarded"
export const BID_STATUS = [
    "Active",
    "Completed",
    "Awarded",
    "Not Awarded",
] as const
export const BidStatusOptions: {value: BidStatus, label: BidStatus}[] = [
    {value: "Active", label: "Active"},
    {value: "Completed", label: "Completed"},
    {value: "Awarded", label: "Awarded"},
    {value: "Not Awarded", label: "Not Awarded"},
]

export type BidTemplate = "Bid Default" | "Finishout"
export const BidTemplateOptions: {value: BidTemplate, label: BidTemplate}[] = [
    {value: "Bid Default", label: "Bid Default"},
    {value: "Finishout", label: "Finishout"},
]